import React, { Component } from 'react';
import { navigate, Link } from 'gatsby';
import { Col } from "reactstrap";
import Img from "gatsby-image";

class ImageCard extends Component {
  constructor(props) {
    super(props);
  }
  createMarkup(tag) {
    return { __html: tag };
  }
  pageNavigate = pagePath => {
    navigate(pagePath);
  };
  render() {
    let lg = 4, md = 4, sm = 6, xs = 6, offset = 0, xsmoffset = 0;
    if (this.props.item === "chubs") {
      lg = 6;
      md = 6;
      sm = 10;
      xs = 10;
      offset = 3;
      xsmoffset = 1;
    }
    return (
      <Col className="text-center h-100"
        lg={{ size: lg, offset: offset }}
        md={{ size: md, offset: offset }}
        sm={{ size: sm, offset: xsmoffset }}
        xs={{ size: xs, offset: xsmoffset }}
        onClick={() => { this.pageNavigate("/" + this.props.type + "/" + this.props.slug + "/"); }}>
        {
          this.props.type === "recipes" ?
            <Img
              className={this.props.imgClass}
              alt={this.props.alt}
              /* fluid={this.props.imgSrc} */
              imgStyle={{ objectFit: 'cover' }}
              fluid={{ ...this.props.imgSrc, aspectRatio: 1 }}
            />
            :
            <Img
              className={this.props.imgClass}
              alt={this.props.alt}
              fluid={this.props.imgSrc}
            />
        }
        <h3 
          className={this.props.itemTextClass}
          >
            <Link 
              to={"/" + this.props.type + "/" + this.props.slug + "/"}
              dangerouslySetInnerHTML={this.createMarkup(this.props.itemText)}
              title={this.props.alt}
              >                
              </Link>
          </h3>
      </Col>
    );
  }
}
export default ImageCard;